import React from 'react';

const StarTraderChallenge = () => {
  return (
    <div style={{ fontFamily: 'Nunito Sans', backgroundColor: '#FFFFFF', color: '#232830', padding: '40px 20px' }}>
      {/* Hero Section */}
      <section style={{ textAlign: 'center', marginBottom: '40px' }}>
        <h1 style={{ color: '#FF7C24', fontSize: '34px', marginBottom: '10px' }}>🎯 The 30-Day SmartChart Challenge</h1>
        <p style={{ fontSize: '18px', maxWidth: '600px', margin: '0 auto' }}>
          Make 1 Trading Decision a Day. Learn. Compete. Win Big.
        </p>
        <p style={{ fontSize: '16px', color: '#666', marginTop: '10px' }}>
          📈 Powered by <strong>Fintorro's AI + Live Charts</strong> & backed by <strong>Star Trader</strong>
        </p>
        <button style={ctaButtonStyle}>🔐 Join the Challenge</button>
      </section>

      {/* How It Works Section */}
      <section style={{ marginBottom: '40px' }}>
        <h2 style={sectionTitleStyle}>⚡ How It Works</h2>
        <ul style={{ listStyle: 'none', paddingLeft: 0, fontSize: '16px' }}>
          <li>1️⃣ Sign up for free — no real money needed</li>
          <li>2️⃣ Get 1 chart-based question daily (30 days total)</li>
          <li>3️⃣ Choose: <strong>Buy</strong>, <strong>Sell</strong>, <strong>Hold</strong>, or <strong>No Trade</strong></li>
          <li>4️⃣ Earn 🪙 coins for smart decisions</li>
          <li>5️⃣ Climb the leaderboard to win epic prizes</li>
        </ul>
        <p style={{ fontStyle: 'italic', fontSize: '14px', color: '#999' }}>
          ⏳ Miss a day? That chart is gone forever.
        </p>
      </section>

      {/* Prizes Section */}
      <section style={{ marginBottom: '40px' }}>
        <h2 style={sectionTitleStyle}>🎁 What You Can Win</h2>
        <ul style={{ fontSize: '16px', paddingLeft: '20px' }}>
          <li>🥇 <strong>1st:</strong> $500 Star Trader Demo Account or Funding Credit</li>
          <li>🥈 <strong>2nd:</strong> 6 Months of FinTorro Pro Access</li>
          <li>🥉 <strong>3rd:</strong> FinTorro Merch + Star Trader Swag</li>
        </ul>
      </section>

      {/* Why Join Section */}
      <section style={{ marginBottom: '40px' }}>
        <h2 style={sectionTitleStyle}>🔥 Why Join?</h2>
        <ul style={{ fontSize: '16px', paddingLeft: '20px' }}>
          <li>✅ No real money. No risk.</li>
          <li>✅ Realistic live charts and trading decisions</li>
          <li>✅ Learn-by-doing with AI feedback</li>
          <li>✅ Build daily trading discipline in 5 mins a day</li>
          <li>✅ Get noticed by brokers — open doors to funding</li>
        </ul>
      </section>

      {/* Signup Section */}
      <section style={{ marginBottom: '40px' }}>
        <h2 style={sectionTitleStyle}>🚀 Join the Challenge Now</h2>
        <form style={{ maxWidth: '400px', margin: '0 auto' }}>
          <input type="text" placeholder="First Name" style={inputStyle} required /><br />
          <input type="email" placeholder="Email Address" style={inputStyle} required /><br />
          <label style={{ display: 'block', marginTop: '10px', fontSize: '14px' }}>
            <input type="checkbox" required /> I’d like to receive trading offers from Star Trader.
          </label>
          <button type="submit" style={{ ...ctaButtonStyle, marginTop: '16px' }}>
            🧠 Start Challenge Now →
          </button>
        </form>
      </section>

      {/* Footer Section */}
      <footer style={{ textAlign: 'center', fontSize: '14px', color: '#666' }}>
        <p>Download the FinTorro app to get notified when your chart is live.</p>
        <div style={{ marginTop: '10px' }}>
          <a href="#" style={footerLinkStyle}>App Store</a> | <a href="#" style={footerLinkStyle}>Google Play</a>
        </div>
        <div style={{ marginTop: '10px' }}>
          <a href="#" style={footerLinkStyle}>Privacy Policy</a> | <a href="#" style={footerLinkStyle}>Terms of Use</a>
        </div>
      </footer>
    </div>
  );
};

const ctaButtonStyle = {
  backgroundColor: '#FF7C24',
  color: '#FFFFFF',
  fontSize: '16px',
  padding: '12px 20px',
  border: 'none',
  borderRadius: '12px',
  cursor: 'pointer',
  transition: 'transform 0.2s ease-in-out',
};

const inputStyle = {
  width: '100%',
  padding: '10px',
  fontSize: '16px',
  margin: '10px 0',
  borderRadius: '8px',
  border: '1px solid #ccc',
};

const sectionTitleStyle = {
  color: '#FF7C24',
  fontSize: '24px',
  marginBottom: '16px',
};

const footerLinkStyle = {
  color: '#FF7C24',
  textDecoration: 'none',
  margin: '0 8px',
};

export default StarTraderChallenge;